import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.SUBSCRIPTION_EDIT_SUCCESS, data: data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.SUBSCRIPTION_EDIT_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const subscriptionEdit = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: CONST.SUBSCRIPTION_EDIT_REQUEST });

    axios.put(`/subscriptions/${id}`, data).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
